<template>
  <section>
    <b-card> Gz Kitap && Panel</b-card>
    <HomeChart />
    <HomeStoreSales />
    <HomeProductSales />
    <HomeBrandSales />
    <HomeStats />
  </section>
</template>

<script>
import HomeStats from './home/HomeStats.vue'
import HomeChart from './home/HomeChart.vue'
import HomeProductSales from './home/HomeProductSales.vue'
import HomeBrandSales from './home/HomeBrandSales.vue'
import HomeStoreSales from './home/HomeStoreSales.vue'

export default {
  name: 'Home',
  components: { HomeStats, HomeChart, HomeProductSales, HomeBrandSales, HomeStoreSales },
  data: () => ({}),
  created() {
    this.$store.dispatch('question/getAll2')
    this.$store.dispatch('orderQuestion/getAll')
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
